module.exports = new __parcel__URL__("pvp_victory_icon_label.e71401e8.png").toString();